// extracted by mini-css-extract-plugin
export default {"equireheading":"page_equireheading__UQFSS","inputmodified":"page_inputmodified__zz9R6"};